module.exports = __webpack_public_path__ + "static/media/file-chart-line.127283a2.svg";